import { render, staticRenderFns } from "./PaginationControl.vue?vue&type=template&id=71afef86&scoped=true"
import script from "./PaginationControl.vue?vue&type=script&lang=js"
export * from "./PaginationControl.vue?vue&type=script&lang=js"
import style0 from "./PaginationControl.vue?vue&type=style&index=0&id=71afef86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71afef86",
  null
  
)

export default component.exports